<evc-nav-button type="cta" size="xxl" variant="round" (click)="openAddBookmarkDialog()" *callToAction>
  <span class="top-cta-label"> {{callToActionLabel.label | optionalAsync}} </span>
  <svg class="bookmarks-icon" width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 3.5C4 2.67188 4.67188 2 5.5 2V3.5V15.7937L9.56563 12.8906C9.825 12.7031 10.1781 12.7031 10.4375 12.8906L14.5 15.7937V3.5H5.5V2H14.5C15.3281 2 16 2.67188 16 3.5V17.25C16 17.5312 15.8438 17.7875 15.5938 17.9156C15.3438 18.0437 15.0438 18.0219 14.8156 17.8594L10 14.4219L5.18438 17.8594C4.95625 18.0219 4.65625 18.0437 4.40625 17.9156C4.15625 17.7875 4 17.5312 4 17.25V3.5Z"
      fill="currentColor"
    />
  </svg>
</evc-nav-button>

<section id="'report">
  <powerbi-report [embedConfig]="reportConfig" class="powerbi-report" [phasedEmbedding]="false" [eventHandlers]="eventHandlersMap"> </powerbi-report>
</section>
